var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Warning,{attrs:{"tree-title":"技术主题","body-title":"技术预警","category-field":_setup.categoryField}})
}
var staticRenderFns = []

export { render, staticRenderFns }